import { AxiosResponse } from 'axios';
import AegisV2 from '@tencent/aegis-web-sdk-v2';
import { TApiError } from 'common/apiRequest/Request';
import Message from 'common/components/Message';
import { NO_COMPANY_ERROR } from 'common/constants/Constants';
import Utils from 'common/utils';

type TError = Partial<TApiError['response']>;

class ResponseInterceptors {
  public onSuccess = (response: AxiosResponse<any, any>): Promise<any> => {
    window.aegis?.report({
      type: 'api',
      level: AegisV2.logLevel.INFO,
      msg: Utils.aegisSuccessInfo(response),
      status: response.status,
    });

    return Promise.resolve(response.data);
  };

  public onError = (error: TApiError) => {
    const err = error.response || { status: 0 };

    window.aegis?.report({
      type: 'api',
      level: AegisV2.logLevel.AJAX_ERROR,
      msg: Utils.aegisErrorInfo(error),
      status: err.status,
    });

    return this.handleError(err);
  };

  public handleError = (error: TError): any => {
    const status = _.get(error, 'status');
    switch (status) {
      case 401:
        Utils.handleNoAuth();
        return Promise.reject(error);
      case 403:
        this.handleForbidden(error);
        return Promise.reject(error);
      case 412:
        this.handleNoCompany(NO_COMPANY_ERROR);
        return Promise.reject(error);
      default:
        return Promise.reject(error);
    }
  };

  // 自定义域名下，域名不可用则跳转到当前自定义域名的 IDP 错误页
  private handleNoCompany = (errCode: string) => {
    Utils.redirectToIdp(undefined, `/sso_login/error?errCode=${errCode}`);
  };

  // 403 无权限处理
  private handleForbidden = async (error: TError) => {
    const agc = _.get(error, 'data.errMessage');
    // get请求，即获取数据的方法不抛出错误消息
    if (error?.config?.method !== 'get' && agc) {
      const content = await Utils.getPermsErrMsgByCode(agc);
      Message.error({ content });
    }
  };
}

export default new ResponseInterceptors();
